import React from 'react';
type SectionHeadingProps = {
  id?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
};
export function SectionHeading({
  id,
  title,
  subtitle,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const isCentered = align === 'center';
  return <div className={`${isCentered ? 'mx-auto max-w-[720px] text-center' : 'max-w-[660px] text-left'} ${className}`} data-id="element-231" data-mp="3k0ygy8sfb398">
      <h2 id={id} className="font-display text-[30px] font-extrabold leading-[1.0] tracking-[-0.015em] text-ink sm:text-[42px]" data-id="element-232" data-mp="bmgcsi5ls7uw">
        {title}
      </h2>

      {subtitle && <p className={`mt-5 text-[16px] font-semibold leading-[1.5] text-muted sm:text-[18px] ${isCentered ? 'mx-auto max-w-[580px]' : 'max-w-[580px]'}`} data-id="element-233" data-mp="1sptrss8wpml">
          {subtitle}
        </p>}
    </div>;
}